'use client';
import { jsx as _jsx } from "react/jsx-runtime";
import Link from '@lichtblick/link';
import { Text } from '@lichtblick/photon/atoms/text/text';
import { usePathname } from 'next/navigation';
import styles from './navigation-item.module.scss';
const normalizePath = (path)=>path === '/' ? '/' : path.replace(/\/+$/, '');
export const NavigationItem = ({ href, text })=>{
    const pathname = usePathname();
    return /*#__PURE__*/ _jsx("li", {
        className: styles.item,
        children: /*#__PURE__*/ _jsx(Link, {
            className: styles.link,
            href: href,
            tabIndex: href ? undefined : 0,
            children: /*#__PURE__*/ _jsx(Text, {
                bold: normalizePath(pathname) === normalizePath(href),
                className: styles.text,
                size: "xs",
                children: text
            })
        })
    });
};

//# sourceMappingURL=NavigationItem.js.map